//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Confirm from '../../../../../shared-components/vuetify/dialog/Confirm';

export default {
  name: 'TransferenciaPosseDefinitivaPasso5',
  props: {
    transferencia: Object,
  },
  components: {
    Confirm,
  },
  data() {
    return {
      resources: this.$api.transferenciaPosseDefinitiva(this.$resource),

      passo: 5,
      rules: {
        required: value => !!value || this.$t('message.campo_obrigatorio'),
      },
    };
  },
  methods: {
    cancelar() {
      this.$emit('TRANSFERENCIA_DEFINITIVA_CANCELAR');
    },
    concluir() {
      if (this.$refs.form.validate()) {
        this.$emit('TRANSFERENCIA_DEFINITIVA_CONCLUIR', this.transferencia);
      }
    },
    voltarPasso() {
      this.$emit('TRANSFERENCIA_DEFINITIVA_VOLTAR', this.passo - 1);
    },
    confirmarConclusao() {
      if (this.$refs.form.validate()) {
        this.$refs.confirmDialog.open();
      }
    },
  },
  mounted() {
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/transferencia-posse/definitiva/TransferenciaPosseDefinitivaPasso5.vue?vue&type=script&lang=js&